__turbopack_context__.v({
  "btn": "CartList-module-scss-module__2MsXVq__btn",
  "cartList": "CartList-module-scss-module__2MsXVq__cartList",
  "selected": "CartList-module-scss-module__2MsXVq__selected",
  "visuallyHidden": "CartList-module-scss-module__2MsXVq__visuallyHidden",
});
